import { action, createRequestTypes } from '@/utils/actions.utils'

export const UPLOAD_RESOURCES = 'UPLOAD_RESOURCES'
const uploadResources = ({ domain, entity, files }) => {
	return action(UPLOAD_RESOURCES, { domain, entity, files })
}

export const UPLOAD_RESOURCE = createRequestTypes('UPLOAD_RESOURCE')
const uploadResource = {
	success: (requestUuid, details) => action(UPLOAD_RESOURCE.SUCCESS, { requestUuid, details }),
	error: (requestUuid, file, error) => action(UPLOAD_RESOURCE.FAILURE, { requestUuid, file, error })
}

export const UPDATE_RESOURCE_UPLOAD_PROGRESS = 'UPDATE_RESOURCE_UPLOAD_PROGRESS'
const updateResourceUploadProgress = (requestUuid, progress) => {
	return action(UPDATE_RESOURCE_UPLOAD_PROGRESS, { requestUuid, progress })
}

export const REMOVE_RESOURCE = 'REMOVE_RESOURCE'
const removeResource = (resource) => {
	return action(REMOVE_RESOURCE, resource)
}

export const ENQUEUE_FILE = 'ENQUEUE_FILE'
const enqueueFile = (requestUuid, fileName) => action(ENQUEUE_FILE, { requestUuid, fileName })

export default {
	uploadResources,
	uploadResource,
	updateResourceUploadProgress,
	removeResource,
	enqueueFile
}
